import { IncludeType } from '../../../common';
import { Family } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

/**
 * Fetches a family by ID with specified locale and include type.
 *
 * @param familyId - The ID of the family to fetch.
 * @param locale - The locale for the market.
 * @param includeType - Specifies the type of attributes to include (default is `IncludeType.Available`).
 * @returns A promise that resolves to a `Family` object or `null` if not found or in case of an error.
 */
export const getFamily = async (
  familyId: number,
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<Family | null> => {
  try {
    const queryParams = new URLSearchParams({
      include: includeType,
      marketLocale: locale,
    }).toString();

    const url = `/family/${familyId}?${queryParams}`;
    const response = await productCatalogueHttp.get<Family>(url);

    return response?.data ?? null;
  } catch (error) {
    console.error(`Error fetching family with ID ${familyId}:`, error);
    return null;
  }
};
